
<app-header></app-header>
    <!-- End Hero -->
    <main id="main">
        <router-outlet></router-outlet>   
    </main>
<!-- End #main -->
<app-footer></app-footer>